module.exports = __webpack_public_path__ + "static/media/Ripple-1s-200px.ad3795dd.gif";